export default __webpack_public_path__ + "static/media/homestar-new.566a7feb.jpg";